import React, {useEffect} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {useCurrentUser, useLoggedIn} from "../context/contextHooks";
import MainMenu from "./MainMenu";
import {useSxStyles as sx} from "../styles/sxStyles";




function Header() {
    const [isLoggedIn, setIsLoggedIn] = useLoggedIn();

    useEffect(() => {
        setIsLoggedIn(isLoggedIn);
    }, [isLoggedIn]);

    return (
        <AppBar position="static" color="transparent">
            <Toolbar>
                {isLoggedIn ? <MainMenu/> : ''}
                <div style={{ flexGrow: 1 }} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={"/Logo-Neumo-Payments-logo.png"} alt="Neumo Logo" style={{ height: '35px', marginRight: '16px' }} />
                    <Typography variant="h6" sx={sx.title}>Virtual Terminal</Typography>
                </div>
            </Toolbar>
        </AppBar>
    );
}

export default Header;

